<template>
  <div class="warp">
    <div class="warp-content">
      <div class="flex-1 flex">
        <div class="box">
          <div class="box-content item-1">
            <div class="title">物业信息</div>
            <div class="flex-16"></div>
            <div class="flex item-1-center">
              <div class="item-1-center-img"></div>
              <div class="flex-1">
                <div class="font-99">企业名称：</div>
                <div class="font-66 margin-top-8">{{pageData.companyName}}</div>
                <div class="font-66 margin-top-20"><i class="el-icon-phone-outline"></i> {{pageData.contactTel}}</div>
              </div>
              <div class="item-1-center-right">
                <ul>
                  <li>
                    <div class="label-value ">{{pageData.areaNumber}}</div>
                    <div class="label">项目数量</div>
                  </li>
                  <li>
                    <div class="label-value ">{{pageData.equipmentNumber}}</div>
                    <div class="label">监控设备</div>
                  </li>
                  <li>
                    <div class="label-value ">{{pageData.onLineEquipNumber}}</div>
                    <div class="label">在线设备</div>
                  </li>
                  <li>
                    <div class="label-value ">{{pageData.onLineRate}}</div>
                    <div class="label">在线率</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="flex-16"></div>
            <div class="flex-1 item-1-map">
              <baidu-map id="allmap" @ready="mapReady" :scroll-wheel-zoom="true">
                <template v-if="BMap">
                  <!-- bm-marker 就是标注点 定位在point的经纬度上 跳动的动画 -->
                  <bm-marker :position="getPoint(item.latitude,item.longitude)" animation="BMAP_ANIMATION_BOUNCE" v-for="(item,index) in pageData.locationList" :key="index">
                  </bm-marker>
                </template>
              </baidu-map>
            </div>
          </div>
        </div>
        <div class="flex10"></div>
        <div class="flex-1 flex">
          <div class="box">
            <div class="box-content item-2">
              <div class="title">告警统计</div>
              <div class="flex-16"></div>
              <div class="flex-1">
                <ul>
                  <li>
                    <div>
                      <div class="font-66 font-size-24">{{pageData.monthAlarmNumber}}</div>
                      <div class="font-66">本月累计告警总数</div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="font-66 font-size-24">{{pageData.currentAlarmNumber}}</div>
                      <div class="font-66">当日告警数</div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="font-66 font-size-24">{{pageData.handleNumber}}</div>
                      <div class="font-66">已处理告警数</div>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div class="font-66 font-size-24">{{pageData.unHandleNumber}}</div>
                      <div class="font-66">未处理告警数</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex10"></div>
          <div class="box">
            <div class="box-content item-2">
              <div class="title flex">
                <div class="flex-1">告警类型占比分析</div>
                <el-radio-group size="small" v-model="dateType" @change="dateTypeChange">
                  <el-radio-button label="day">日</el-radio-button>
                  <el-radio-button label="month">月</el-radio-button>
                  <el-radio-button label="year">年</el-radio-button>
                </el-radio-group>
              </div>
              <div class="flex-16"></div>
              <div class="flex-1 chart-box" id="pie"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex10"></div>
      <div class="flex-1 flex">
        <div class="box">
          <div class="box-content item-2">
            <div class="title flex">
              <div class="flex-1">告警趋势分析</div>
              <el-radio-group v-model="trendDateType" size="small" @change="trendDateTypeChange">
                <el-radio-button label="day">日</el-radio-button>
                <el-radio-button label="month">月</el-radio-button>
                <el-radio-button label="year">年</el-radio-button>
              </el-radio-group>
            </div>
            <div class="flex-16"></div>
            <div class="flex-1" id="line"></div>
          </div>
        </div>
        <div class="flex10"></div>
        <div class="box">
          <div class="box-content item-2">
            <div class="title flex" style="padding-bottom:6px">
              <div class="flex-1">告警记录（共{{recordList.length}}条）</div>
              <el-select size="small" v-model="eventType" @change="eventTypeChange">
                <el-option :value="1" :label="'全部'"></el-option>
                <el-option :value="2" :label="'未确认'"></el-option>
                <el-option :value="3" :label="'未处理'"></el-option>
              </el-select>
            </div>
            <div class="flex-1">
              <div class="item-event flex" v-for="(item,index) in recordList" :key="index">
                <div class="flex-1 font-99">
                  <div class="p-bottom">告警来源：<label class="font-66">{{item.rentalAreaName}}</label></div>
                  <div class="p-bottom">告警名称：<label class="font-66">{{ getEventTypeName( item.code)}}</label> 告警级别：<label class="font-66">{{item.levelName.length==0?item.level:item.levelName}}</label>告警状态：<label class="font-66">{{ getEventState( item.state)}}</label></div>
                  <div class="p-bottom">确认人：<label class="font-66">{{item.confirmingUserNickname}}</label> 确认时间：<label class="font-66">{{item.confirmingTime}}</label></div>
                  <div class="p-bottom">处理人：<label class="font-66">{{item.handlingUserNickname}}</label> 处理时间：<label class="font-66">{{item.handlingTime}}</label></div>
                  <div>内容：<label class="font-66">{{item.content}}</label></div>
                </div>
                <div class="item-event-btn-box">
                  <el-button type="text" @click="bindShowDetails(item)">详情</el-button>
                  <div class="btn btn-disabled" :class="{'btn-blue':item.state===2}" @click="bindConfirmEvent(item)">确认告警</div>
                  <div class="btn btn-disabled" :class="{'btn-green':item.state===3}" @click="bindHandleEvent(item)">处理告警</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="告警详情" :visible.sync="showDetails" width="800px">
      <nk-chart v-if="showDetails" :data="chartData" :timeTitle="timeTitle" title="波形分析" :unit="unit" :showTitle="false" :markLine="markLine" class="dialog"></nk-chart>
    </el-dialog>
    <el-dialog title="填写处理信息" :visible.sync="handleEventVisible" width="500px">
      <el-form label-width="0px">
        <el-form-item>
          <el-input type="textarea" v-model="comment"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleEvent">确定</el-button>
          <el-button style="margin-right: 15px" @click="handleEventVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import NkChart from '@/components/common/NkChart.vue'
import api from '@common/api/index.js'
import DateTool from '@/utils/dateTool.js'
import handleData from '@/utils/handleData.js'
import { EVEN } from '@/config/data.js'
export default {
  components: { NkChart },
  data () {
    return {
      pageData: {
        recordList: []
      },
      recordListBack: [],
      recordList: [],
      BMap: null,
      point: "",
      pieChart: null,
      lineChart: null,
      dateType: 'day',
      trendDateType: "day",
      showDetails: false,
      chartData: [],
      unit: '', //单位
      markLine: null,
      eventId: null,
      handleEventVisible: false,
      comment: '',
      eventType: 1,
    }
  },
  mounted () {
    this.drawPie([])
    this.drawLine([], [])
    this.getData()
  },
  methods: {
    getData () {
      api.tmp.getElectricSaftyUseOverviewForProperty().then(res => {
        if (res.success && res.data) {
          this.pageData = res.data

          let recordList = []
          for (let i = 0; i < res.data.recordList.length; i++) {
            let element = res.data.recordList[i];
            element.state = 1
            if (element.confirmingUserId == null) {
              element.state = 2
            }
            if (element.handlingUserId == null && element.state != 2) {
              element.state = 3
            }
            recordList.push(element)
          }
          this.recordListBack = recordList
          this.recordList = recordList
          this.dateTypeChange("day")
          this.trendDateTypeChange("day")
        }
      })
    },
    eventTypeChange (val) {
      let data = JSON.parse(JSON.stringify(this.recordListBack))

      if (val === 0) {
        this.recordList = data
        return
      }
      let recordList = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].state == val) {
          recordList.push(data[i])
        }
      }
      this.recordList = recordList
    },
    mapReady ({ BMap, map }) {
      this.BMap = BMap
      // 选择一个经纬度作为中心点
      this.point = new BMap.Point(113.45182059683474, 23.167485554278006);
      map.centerAndZoom(this.point, 16);
    },
    getPoint (latitude, longitude) {
      return new this.BMap.Point(latitude, longitude)
    },
    dateTypeChange (val) {
      switch (val) {
        case 'day':
          this.drawPie(this.listToEChartPieData(this.pageData.eventTypeDayList))
          break;
        case 'month':
          this.drawPie(this.listToEChartPieData(this.pageData.eventTypeMonthList))
          break;
        case 'year':
          this.drawPie(this.listToEChartPieData(this.pageData.eventTypeYearList))
          break;
      }
    },
    listToEChartPieData (arr) {
      let data = []
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        const eventItem = EVEN.find(c => c.id == element.typeName)
        data.push({ value: element.rate, name: eventItem ? eventItem.label : element.typeName },)
      }
      return data
    },
    trendDateTypeChange (val) {
      let obj = null
      switch (val) {
        case 'day':
          obj = this.getListToXDataAndData(this.pageData.dayTrendList)
          break;
        case 'month':
          obj = this.getListToXDataAndData(this.pageData.monthTrendList)
          break;
        case 'year':
          obj = this.getListToXDataAndData(this.pageData.yearTrendList)
          break;
      }
      this.drawLine(obj.xData, obj.data)
    },
    getListToXDataAndData (arr) {
      let xData = []
      let data = []
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        xData.push(element.time)
        data.push(element.currentCount)
      }
      return { xData: xData, data: data }
    },
    getEventTypeName (code) {
      const item = EVEN.find(c => c.id == code)
      if (item) {
        return item.label
      } else {
        return code
      }
    },
    drawPie (data) {
      if (!this.pieChart) {
        this.pieChart = this.$echarts.init(document.getElementById('pie'))
      } else {
        this.pieChart.clear()
      }

      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '5%',
          left: 'center'
        },
        series: [
          {
            name: '告警类型',
            type: 'pie',
            radius: ['30%', '50%'],
            center: ['50%', '40%'],
            data: data
          }
        ]
      };

      this.pieChart.setOption(option)
    },
    drawLine (xData, data) {
      if (!this.lineChart) {
        this.lineChart = this.$echarts.init(document.getElementById('line'))
      } else {
        this.lineChart.clear()
      }
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '15%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: xData
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '告警数',
            type: 'line',
            lineStyle: {
              color: '#00AAFF'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#00AAFF50' // 0% 处的颜色
                }, {
                  offset: 1, color: '#00AAFF50' // 100% 处的颜色
                }],
              }
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#00AAFF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#00AAFF' // 100% 处的颜色
                }],
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ]
            },
            smooth: true,
            data: data
          }
        ]
      };
      this.lineChart.setOption(option)
    },
    bindConfirmEvent (item) {
      if (item.state !== 2) {
        return
      }
      //点击确认告警
      this.$confirm('是否确认您选中的告警?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api.event.confirmEvent([item.id]).then(res => {
            this.$message('确认告警成功！')
            item.confirmingUserNickname = this.$store.user.info.nickname
            item.state = 3
          })
        })
        .catch(() => { })
    },
    bindHandleEvent (item) {
      if (item.state !== 3) {
        return
      }
      //判断告警是否已经确认
      this.eventId = item.id
      this.comment = ''
      this.handleEventVisible = true
    },
    async handleEvent () {
      if (!this.comment) {
        this.$message.error('处理信息不能为空！')
        return
      }
      //点击告警处理确定
      let res = await api.event.handleEvent(this.eventId, this.comment)
      if (!res) {
        return
      }
      this.$message('处理成功！')
      this.handleEventVisible = false
    },
    async bindShowDetails (row) {
      //点击显示详细信息
      if (!row.regulationParam) {
        this.$message.warning('当前告警没有告警详情')
        return
      }
      let regulationParam = JSON.parse(row.regulationParam)
      let eventTime = new Date(row.eventTime)
      let date = new Date()
      let pointCode = regulationParam.pointCode
      let pointNumber = regulationParam.pointNumber
      date.setMinutes(date.getMinutes() - 30)
      let startTime, endTime
      if (eventTime < date) {
        startTime = new Date(row.eventTime)
        endTime = new Date(row.eventTime)
        startTime.setMinutes(startTime.getMinutes() - 30)
        endTime.setMinutes(endTime.getMinutes() + 30)
      } else {
        startTime = new Date(row.eventTime)
        endTime = new Date()
        startTime.setMinutes(startTime.getMinutes() - 30)
      }
      let strStartTime = DateTool.format(startTime, 'yyyy-MM-dd hh:mm:ss')
      let strEndTime = DateTool.format(endTime, 'yyyy-MM-dd hh:mm:ss')
      let valueAllElem = [
        {
          measureId: row.measureId,
          pointCode: pointCode,
          pointNumber: pointNumber,
        },
      ]
      console.log('strStartTime', strStartTime)
      console.log('strEndTime', strEndTime)
      let res = await api.measuring.getMeasuringValueAll2(
        valueAllElem,
        strStartTime,
        strEndTime,
        0,
        0
      )
      if (!res) {
        return
      }
      let selectNodes = [{ id: row.measureId, label: row.measureName }]
      let itemCollect = window.baseConfig.collectData.find(
        (obj) => obj.code == pointCode
      )
      if (!itemCollect) {
        return
      }
      let codes = [
        {
          code: itemCollect.code,
          title: itemCollect.name,
          show: true,
        },
      ]
      let chartData = handleData.matchMeasuringData(
        res.data,
        selectNodes,
        codes
      )
      let markLineData = []
      if (regulationParam.threshold) {
        markLineData.push({
          yAxis: regulationParam.threshold,
          name: '告警值',
          lineStyle: {
            color: 'red',
          },
        })
      }
      if (regulationParam.recover) {
        markLineData.push({
          yAxis: regulationParam.recover,
          name: '恢复值',
          lineStyle: {
            color: 'green',
          },
        })
      }
      this.markLine = {
        data: markLineData,
      }
      this.timeTitle = strStartTime + '~' + strEndTime
      this.chartData = chartData
      this.showDetails = true
    },
    getEventState (val) {
      let label = ''
      switch (val) {
        case 1:
          label = "已处理"
          break;
        case 2:
          label = "未确认"
          break;
        case 3:
          label = "未处理"
          break;
      }
      return label
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .warp-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    .box {
      background: #fff;
      flex: 1;
      overflow: auto;
      box-sizing: border-box;
      .box-content {
        width: 100%;
        height: 100%;
        overflow: auto;
        padding: 12px 24px;
        box-sizing: border-box;
      }
      .title {
        font-size: 14px;
        font-family: FZLTZHK--GBK1-0, FZLTZHK--GBK1;
        font-weight: normal;
        color: #666666;
        line-height: 14px;
      }
    }
    .item-1 {
      display: flex;
      flex-flow: column;
      .item-1-center {
        flex: 0 0 88px;
        overflow: hidden;
        .item-1-center-img {
          flex: 0 0 88px;
          background: #f5f7fa;
          margin-right: 10px;
        }
        .item-1-center-right {
          flex: 0 0 382px;
          ul {
            list-style: none;
            padding: 0px;
            margin: 0px;
            li {
              float: left;
              width: 88px;
              height: 88px;
              margin-right: 10px;
              padding: 17px 0px;
              box-sizing: border-box;
              text-align: center;
              &:last-child {
                margin-right: 0px;
              }
              .label-value {
                height: 36px;
                line-height: 36px;
                font-size: 24px;
                color: #666666;
              }
              .label {
                font-size: 14px;
                color: #999999;
              }
              &:hover {
                background: #e6f7ff;
                .label-value {
                  color: #0080ff;
                }
                .label {
                  color: #0080ff;
                }
              }
            }
          }
        }
      }
      .item-1-map {
        background: #fafafa;
        position: relative;
        overflow: hidden;
      }
    }
    .item-2 {
      display: flex;
      flex-flow: column;
      ul {
        width: 100%;
        height: 100%;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: calc(50% - 6px);
          height: calc(50% - 6px);
          div {
            text-align: center;
          }
          &:nth-child(1) {
            background: linear-gradient(180deg, #e8f8ff 0%, #cceeff 100%);
            margin-right: 6px;
            margin-bottom: 6px;
          }
          &:nth-child(2) {
            background: linear-gradient(180deg, #ddf4ed 0%, #b8e6d6 100%);
            margin-left: 6px;
            margin-bottom: 6px;
          }
          &:nth-child(3) {
            background: linear-gradient(180deg, #f4f4ce 0%, #e6e6a1 100%);
            margin-right: 6px;
            margin-top: 6px;
          }
          &:nth-child(4) {
            background: linear-gradient(180deg, #e8e4fb 0%, #ccc4f5 100%);
            margin-left: 6px;
            margin-top: 6px;
          }
        }
      }
    }
    .item-event {
      background: #f5f7fa;
      border: 1px dashed #dddddd;
      padding: 12px;
      margin-bottom: 10px;
      .p-bottom {
        padding-bottom: 6px;
      }
      .item-event-btn-box {
        flex: 0 0 90px;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
      }
    }
    ul {
      list-style: none;
      padding: 0px;
      margin: 0px;
      li {
        float: left;
      }
    }
  }
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
  overflow: auto;
}
.margin-left {
  margin-left: 10px;
}
.margin-top {
  margin-top: 10px;
}
.flex10 {
  flex: 0 0 10px;
}
.font-99 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #999999;
  line-height: 20px;
}
.font-66 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #666666;
}
.font-size-24 {
  font-size: 24px;
}
.margin-top-8 {
  margin-top: 8px;
}
.margin-top-20 {
  margin-top: 20px;
}
.flex-16 {
  flex: 0 0 16px;
}
.chart-box {
  overflow: hidden;
}
.btn {
  width: 80px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  margin-bottom: 10px;
  font-size: 14px;
}
.btn-disabled {
  background: #dddddd;
  color: #999999;
}
.btn-blue {
  color: #fff;
  background: #0080ff;
  &:hover {
    cursor: pointer;
  }
}
.btn-green {
  color: #fff;
  background: #52cca3;
  &:hover {
    cursor: pointer;
  }
}

#allmap {
  position: absolute;
  top: -50px;
  left: 0px;
  right: 0px;
  bottom: -50px;
}
</style>